import { Map } from 'immutable';
import reducerChain from '../helpers/chain';
import Constants from '../../constants/index';
import { TopicRecord } from '../../records/index';
import { reducerMerger, reducerRemover, reducerUpdateWatching } from '../helpers/entities';

export const DEFAULT_STATE = Map({});

const topicsDefault = reducerMerger(
	[
		Constants.DELETE_TOPIC,
		Constants.CREATE_TOPIC,
		Constants.UPDATE_TOPIC,
		Constants.FETCH_FEATURED_TOPICS,
		Constants.FETCH_ALL_TOPICS,
		Constants.FETCH_TOPIC,
		Constants.FETCH_TOPIC_BY_NAME,
		Constants.FETCH_ALL_TOPICS_BY_NAME,
	],
	'topics',
	TopicRecord,
);
const topicsWithDelete = reducerRemover(Constants.DELETE_TOPIC);
const topicsWithWatching = reducerUpdateWatching([
	Constants.IS_WATCHING_TOPIC,
	Constants.WATCH_TOPIC,
	Constants.UNWATCH_TOPIC,
]);

export default reducerChain([topicsDefault, topicsWithDelete, topicsWithWatching], DEFAULT_STATE);
